
import React from 'react';
import { cn } from "@/lib/utils";

interface StarBackgroundProps {
  className?: string;
}

export const StarBackground: React.FC<StarBackgroundProps> = ({ className }) => {
  return (
    <div className={cn("fixed inset-0 z-0 overflow-hidden", className)}>
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHJhZGlhbEdyYWRpZW50IGlkPSJhIiByPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAiIHN0b3AtY29sb3I9IiNmZmYiLz48c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiNmZmYiIHN0b3Atb3BhY2l0eT0iMCIvPjwvcmFkaWFsR3JhZGllbnQ+PC9kZWZzPjxwYXRoIGZpbGw9Im5vbmUiIGQ9Ik0wIDBoMTZ2MTZIMHoiLz48Y2lyY2xlIGN4PSI4IiBjeT0iOCIgcj0iMS41IiBmaWxsPSJ1cmwoI2EpIiBmaWxsLW9wYWNpdHk9Ii4yIi8+PC9zdmc+')] opacity-30 pointer-events-none"></div>
      <div className="absolute top-0 left-0 right-0 h-[500px] bg-gradient-to-b from-jade/10 to-transparent opacity-20"></div>
      <div className="absolute -top-40 -left-40 right-40 h-80 bg-jade/10 blur-[100px] rounded-full"></div>
      <div className="absolute top-1/3 -right-40 left-2/3 h-80 bg-jade/10 blur-[100px] rounded-full"></div>
    </div>
  );
};
